export const LAYOUT_SOURCES = {
    DRAWER: 'drawer',
    TOAST: 'toast',
};
